<template>

    <div class="app-switcher" v-click-outside="close">
        <a href="#" @click.prevent="opened = !opened">{{ currentConfig.name }}<i class="img icon-triangle-white-8"></i></a>
        <div class="droplist" v-if="opened">
            <span class="title">Selecteer een applicatie</span>
            <span class="active">{{ currentConfig.name }}</span>
            <a href="#" @click.prevent="switchApp(app)" v-for="app in appConfigs">{{ app.name }}</a>
            <div class="logout">
                <a href="#" @click.prevent="logout">Uitloggen</a>
            </div>
        </div>
    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import find from 'lodash/find'

    @Component({

        name: 'app-switcher',
        props: ['current']
    })
    export default class extends Vue {

        data() {

            return {
                opened: false
            };
        }

        created() {

            this.logger = this.$di.logger.child('AppSwitcher');
        }

        close(){

            this.opened = false;
        }

        get currentConfig(){

            return find(this.$di.config.apps, { id: this.current });
        }

        get appConfigs(){

            return this.$di.config.apps.filter(app => app.id !== this.current);
        }

        switchApp(app){

            this.$di.appSwitcher.navigate(app.id);
        }

        logout(){

            this.$auth.logout();
        }
    }

</script>
